import { defineMessages } from "react-intl";

export const requisitesMessages = defineMessages({
  accountNumber: {
    id: "requisites.accountNumber",
    defaultMessage: "Номер счёта: {accountNumber}",
  },
  bankName: {
    id: "requisites.bankName",
    defaultMessage: "Название банка: {bankName}",
  },
  bik: {
    id: "requisites.bik",
    defaultMessage: "БИК банка: {bikNumber}",
  },
  cardNumber: {
    id: "requisites.cardNumber",
    defaultMessage: "Номер карты: {cardNumber}",
  },
  companyName: {
    id: "requisites.companyName",
    defaultMessage: "Наименование компании: {companyName}",
  },
  correspondentAccount: {
    id: "requisites.correspondentAccount",
    defaultMessage: "Корреспондентский счёт: {correspondentAccount}",
  },
  fullName: {
    id: "requisites.fullName",
    defaultMessage: "ФИО получателя: {fullName}",
  },
  iban: {
    id: "requisites.iban",
    defaultMessage: "IBAN: {ibanNumber}",
  },
  inn: {
    id: "requisites.inn",
    defaultMessage: "ИНН: {innNumber}",
  },
  kpp: {
    id: "requisites.kpp",
    defaultMessage: "КПП: {kppNumber}",
  },
  name: {
    id: "requisites.name",
    defaultMessage: "Название реквизита: {name}",
  },
  pin: {
    id: "requisites.pin",
    defaultMessage: "ПИН: {pinNumber}",
  },
  swift: {
    id: "requisites.swift",
    defaultMessage: "SWIFT-код: {swiftCode}",
  },
});

export const requisitesClearMessages = defineMessages({
  accountNumber: {
    id: "requisites-clear.accountNumber",
    defaultMessage: "Номер счёта",
  },
  bankName: {
    id: "requisites-clear.bankName",
    defaultMessage: "Название банка",
  },
  bik: {
    id: "requisites-clear.bik",
    defaultMessage: "БИК банка",
  },
  cardNumber: {
    id: "requisites-clear.cardNumber",
    defaultMessage: "Номер карты",
  },
  companyName: {
    id: "requisites-clear.companyName",
    defaultMessage: "Наименование компании",
  },
  correspondentAccount: {
    id: "requisites-clear.correspondentAccount",
    defaultMessage: "Корреспондентский счёт",
  },
  fullName: {
    id: "requisites-clear.fullName",
    defaultMessage: "ФИО получателя",
  },
  iban: {
    id: "requisites-clear.iban",
    defaultMessage: "IBAN",
  },
  inn: {
    id: "requisites-clear.inn",
    defaultMessage: "ИНН",
  },
  kpp: {
    id: "requisites-clear.kpp",
    defaultMessage: "КПП",
  },
  name: {
    id: "requisites-clear.name",
    defaultMessage: "Название реквизита",
  },
  pin: {
    id: "requisites-clear.pin",
    defaultMessage: "ПИН",
  },
  swift: {
    id: "requisites-clear.swift",
    defaultMessage: "SWIFT-код",
  },
});
